export const GET_LOGGED_IN = "loggedIn";
export const GET_SOME_SELECTED = "someSelected";
export const GET_SIDEBAR_SELECTED = "sidebarSelected";
export const GET_USER_NAME = "username";
export const GET_USER_ROLE = "userRole";
export const GET_STATUS_COLOR = "statusColor";
export const GET_SIDE_MENU = "dataMenu";
export const GET_SHOW_PRICES = "getShowPrice";
